export const adminNavbarItemsData = [
  { label: "Scanner", path: "/scanner" },
  { label: "Účastníci", path: "/participants" },
  { label: "Organizace", path: "/organizations" },
  { label: "Akce", path: "/event-configuration" },
  { label: "Aktuality", path: "/news-configuration" },
]